import { render, staticRenderFns } from "./AltCoinModal.vue?vue&type=template&id=e8d9bd32&scoped=true&"
import script from "./AltCoinModal.vue?vue&type=script&lang=js&"
export * from "./AltCoinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d9bd32",
  null
  
)

export default component.exports